<template>
  <div id="app">
    <router-view/>
    <!-- <LayoutVue></LayoutVue> -->
  </div>
</template>
<script>
  // import LayoutVue from './components/Layout.vue'
  import axios from '@/utils/request';
  export default {
    name: 'Layout',
    // components: {
    //   LayoutVue
    // },
    created(){
      // if(localStorage.getItem('token')){
      //   this.getData()
      // }
    },
    methods:{
      getData(){
        axios.get('/user_info')
            .then(res => {
                if(res.code == 0){
                  this.$store.commit('setGlobalVar', res.data)
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
      }
    }
  }
</script>

<style>
body,html{
  background: #f2f2f2;
  height:100%
}
#app{
  height:100%
}
*{
  margin: 0;
  padding: 0;
}
.merchart_header{
    padding: 15px 15px 0 15px;
}
.mian{
    padding:0 15px;
}
.page{
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}
.home{
  height:100%;
  background: #fff;
  border-radius: 5px;
  display:flex;
  flex-direction:column
}
.mian{
  flex:1;
}
/* .el-menu-item:hover, .el-submenu__title:hover {
  background-color: transparent !important;
}
.el-menu-item a{
  color:#fff !important;
} */
.el-submenu__title{
  display: flex;
  align-items: center;
}
.el-menu{
  border-right:none !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.el-dialog{
  max-width: 700px;
}
.plform_box .el-submenu .el-submenu__title .el-submenu__icon-arrow {
    display: none;
}
.el-table th.el-table__cell>.cell{
  font-weight: normal !important;
}
/* .el-menu-item a{
  text-decoration: none;
  color: #303133;
} */
 .cate .el-tree{
  background:none !important;
 }
 .el-tabs__content{
    display:none !important;
}
.el-input-group__append, .el-input-group__prepend{
  width:70px !important;
}
.main__phone_item .el-input__inner{
  border: none !important;
  padding: 0 !important;
}
.el-image-viewer__canvas{
  height: 70% !important;
  margin-top: 8%;
}

/* .horizontal-tree .el-tree-node__content {
  display: flex !important;
  align-items: center !important;
  flex-wrap: wrap;
}
 
.horizontal-tree .el-tree-node__children {
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap;
  overflow: unset !important;
}
.el-tree-node__content:hover, .el-upload-list__item:hover {
    background-color: #fff !important;
} */
.el-tree-node__content{
  height: 30px !important;
}
.msg_content .el-table .cell{
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>
